import React, { useState } from 'react';
import { CardBody, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import Switch from "react-bootstrap-switch";
import {useForm} from "react-hook-form";
import {connect} from "react-redux";

// labels
import {
    FL_ONLY_REGISTERED,
    FL_STATUS,
} from "../../../components/i18n/formLabels";

// actions
import {setFilter} from "../../../redux/actions/generalActions/listActions";

// components
import { ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";


function LangFilters(props) {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const [status, setStatus] = useState(filter?.item?.status || null);
    const [translateBase, setTranslateBase] = useState(filter?.item?.translateBase || null);
    const [enabledToEdit, setEnabledToEdit] = useState(filter?.item?.enabledToEdit || null);
    const [toPreload, setToPreload] = useState(filter?.item?.toPreload || null);
    const [saveHisTranslation, setSaveHisTranslation] = useState(filter?.item?.saveHisTranslation || null);
    const [onlyRegistered, setOnlyRegistered] = useState(!props.generalPropouse);

    const cleanFields = () => {
        setStatus(null);
        setTranslateBase(null);
        setEnabledToEdit(null);
        setToPreload(null);
        setSaveHisTranslation(null);
        reset();
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
    });

    const onSubmit = (data, _) => {
        if(!app?.fbDataBase?.id)
            return

        const dataFilter = {
            fbDataBase : {  id : app?.fbDataBase?.id },
            onlyRegistered : onlyRegistered,
            item : {
                ...data,
                status: status,
                translateBase: translateBase,
                enabledToEdit: enabledToEdit,
                toPreload: toPreload,
                saveHisTranslation: saveHisTranslation,
                isDefault:null
            }
        }

        props.setFilter(dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ FL_STATUS }</Label>
                            <br />
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={status}
                                    innerRef={register}
                                    onChange={_ => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ 'Base de traducción' }</Label>
                            <br />
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={translateBase}
                                    innerRef={register}
                                    onChange={_ => setTranslateBase(!translateBase)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ 'Se puede editar' }</Label>
                            <br />
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={enabledToEdit}
                                    innerRef={register}
                                    onChange={_ => setEnabledToEdit(!enabledToEdit)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ 'Para precarga' }</Label>
                            <br />
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={toPreload}
                                    innerRef={register}
                                    onChange={_ => setToPreload(!toPreload)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Guardar traducción</Label>
                            <br />
                            <Switch animate={true} offText={"No"} onText={"Si"}
                                    value={saveHisTranslation}
                                    innerRef={register}
                                    onChange={_ => setSaveHisTranslation(!saveHisTranslation)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{ FL_ONLY_REGISTERED }</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                disabled={app?.fbDataBase === undefined}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(LangFilters)
